// extracted by mini-css-extract-plugin
module.exports = {"fieldInput":"CouponSumField_fieldInput__FmWFJ","input":"CouponSumField_input__9PVVq","inputAffix":"CouponSumField_inputAffix__Y6gvi"};